import { BillingApiClient } from '@fourthwall/services/dist/BillingApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useBillingSummaryQuery = createQueryHook(BillingApiClient.getBillingSummary, {
  queryKey: ['billingSummary'],
})
